module.exports = {"back":"Back"}


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldownCopy.json
// module id = ./src/components/MobileNav/MobileNavDrilldown/mobileNavDrilldownCopy.json
// module chunks = 4